module.exports = __webpack_public_path__ + "static/media/Classes.32f41097.svg";